import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import ReportHeader from '@/components/ReportHeader';

const Container = styled.div`
  padding: 16px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  padding: 16px;
`;

const Card = styled(Link)`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 18px;
  text-decoration: none;
  color: #111827;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: all .2s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(0,0,0,.06);
    border-color: #3b82f6;
  }
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
`;

const Desc = styled.div`
  font-size: 13px;
  color: #6b7280;
`;

const Ponto: React.FC = () => {
  return (
    <Container>
      <ReportHeader title="Ponto" subtitle="Escolha um relatório" />
      <Grid>
        <Card to="/relatorios/ponto/irregularidades-manha">
          <Title>Irregularidades da manhã</Title>
          <Desc>Entradas após 08:10 e lista do callcenter</Desc>
        </Card>
        <Card to="/relatorios/ponto/atrasos">
          <Title>Ranking de atrasos</Title>
          <Desc>Ordene por quantidade (após 08:10) ou por minutos</Desc>
        </Card>
        <Card to="/relatorios/ponto/esquecimento">
          <Title>Esquecimento de batida</Title>
          <Desc>Mostra quais batidas faltaram no dia escolhido</Desc>
        </Card>
      </Grid>
    </Container>
  );
};

export default Ponto;

